import React from 'react';
import AppHeader from '../../../components/AppHeader.tsx';
import { HistoryPage } from '../../../features/history';

const History: React.FC = () => {
  const breadcrumb = [{ label: 'Rezervace' }, { label: 'Historie rezervací' }];

  return (
    <div className="h-full flex flex-col">
      <AppHeader title="Historie rezervací" breadcrumb={breadcrumb} />
      <div className="flex-1 overflow-y-auto">
        <HistoryPage />
      </div>
    </div>
  );
};

export default History;
